import { createSelector } from 'reselect';
import { getIsMESEnabled } from './getIsMESEnabled';
import { getMachineSettings } from './getMachineSettings';
import { getMachine } from './getMachine';

/**
 * When MES is enabled, the valid resource IDs for a machine come from
 * machineSettings.scheduleAs + machineSettings.laborResourceId instead of
 * the GET_ERP_RESOURCES query (which uses machineRef / machineGroupId).
 */
export const getEffectiveErpResources = createSelector(
  [getIsMESEnabled, getMachineSettings, getMachine],
  (isMESEnabled, machineSettings, machine) => {
    if (isMESEnabled) {
      const ids = [...(machineSettings?.scheduleAs || [])];
      if (machineSettings?.laborResourceId) {
        ids.push(machineSettings.laborResourceId);
      }
      return [...new Set(ids)];
    }
    return machine?.erpResources || [];
  }
);
